import { Component, OnInit, Inject     } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode             } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                } from 'src/app/managers/loading/loading.manager';
import { SessionManager                } from 'src/app/managers/session/session.manager';
import { User                          } from 'src/app/beans/login/user/user.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { SlotModelAuto } from 'src/app/beans/slot-model/slot-model.auto.bean';
import { SlotModel } from 'src/app/beans/slot-model/slot-model.bean';
import { Organization } from 'src/app/beans/organization/organization.bean';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { SlotVisibility } from 'src/app/beans/slot/slot.visibility.bean';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';

@Component
({
  selector: 'model.slot.dialog',
  templateUrl: './model.slot.dialog.html',
  styleUrls: ['./model.slot.dialog.scss'],
})

export class ModelSlotDialog implements OnInit 
{
  time : any
  type : number
  count : number

  list : SlotVisibility[]

  constructor
  (
    private dialogRef : MatDialogRef<ModelSlotDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    
    private _handler : HandlerManager,
    private _loader  : LoadingManager,
    private _session : SessionManager,
    private _utils   : UtilsManager,
    private _notifier: NotifierManager
  ) {}

  ngOnInit(): void
  {
    this.init()
  }

  async init()
  {
    console.log(this.data);
    
    this.time = {
      hour : parseInt(this.data?.slot?.time?.substring(0,2)) || 8,
      minute : parseInt(this.data?.slot?.time?.substring(3,5)) || 0
    }
    this.type = this.data?.slot?.type
    this.count = this.data?.slot?.count || 1
    this.list =this.data?.visibilities
  }

  checkTime()
  {
    if(!this.time)
      this.time = {
        hour: 8,
        minute: 0
      }
    
  }

  checkCount(ev?: any)
  {    
    this.count = Math.min(Math.max(this.count, 1), 60)

  }

  //---------------------------------------------------------------------------------------------------

  async confirm()
  {

    this.checkCount()
    this.checkTime()

    let hour, minute
    if ( this.time ) {

      hour    = this.time.hour
      minute  = this.time.minute

      if (this.time.hour < 10) {
        hour = "0" + this.time.hour
      }

      if (this.time.minute < 10) {
        minute = "0" + this.time.minute
      }
    }

    if(this.time == undefined || this.type == undefined || this.count == undefined ){
      this._notifier.show
      ( 
        Notifier.WARNING            , 
        NotifierMessage.GENERIC_MISSING_PARAM
      )
      return
    }
    
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.SLOTMODEL_SLOT,
        slot : {
          time : hour + ":" + minute,
          type : this.type,
          count : this.count
        }
      }
    )
     
    
  }

  cancel()
  {
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }

  //---------------------------------------------------------------------------------------------------

}
